import { Menu, MenuAlignment } from '@shared/components/Menu';
import { SortOption } from '@shared/components/filter/types';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

interface SortOptionsDropdownProps {
  direction?: API.SortDirection;
  onSelect(direction: API.SortDirection): void;
  sortOptions?: SortOption[];
  showButtonLabel?: boolean;
  align?: MenuAlignment;
}

const defaultSortOptions: SortOption[] = [
  {
    id: 'ASC',
    label: i18n('card.actions.sort.ascending'),
    icon: 'arrow-full-up',
    direction: 'ASC',
  },
  {
    id: 'DESC',
    label: i18n('card.actions.sort.descending'),
    icon: 'arrow-full-down',
    direction: 'DESC',
  },
];

export function SortDirectionMenu({
  direction,
  onSelect,
  sortOptions = defaultSortOptions,
  align = 'left',
  showButtonLabel = false,
}: SortOptionsDropdownProps) {
  const selectedOption = sortOptions.find(option => option.id === direction);
  return (
    <Menu align={align}>
      {showButtonLabel && <Menu.Button label={selectedOption?.label} icon={selectedOption?.icon} />}
      {!showButtonLabel && <Menu.IconButton />}
      <Menu.Content>
        <Menu.Options
          options={sortOptions}
          getItemKey={option => option.id}
          getItemLabel={option => option.label}
          getItemIcon={option => option.icon}
          onSelect={option => onSelect(option.id as API.SortDirection)}
          isItemSelected={option => option.id === direction}
        />
      </Menu.Content>
    </Menu>
  );
}
